export const getTransformedSavedSow = (url = '', entities = []) => {
    const path = [
        "/edit-a-sow/entities",
        "/edit-a-sow/product-mapping"
    ]
    if (Array.isArray(entities) && entities.length && path.indexOf(url) > -1) {
        return entities.map(singleEntity =>
            ({ ...singleEntity, products: { ...singleEntity.products, agent: Boolean(singleEntity.agent) } }))
    }
    return []
}


// WEBPACK FOOTER //
// ./src/components/createASow/utils/index.js